<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2023-08-16 09:38:39
 * @LastEditors: 王赵坤
 * @LastEditTime: 2023-12-15 14:31:03
-->
<template>
  <div class="bossboxbodywork">
    <div class="schedule">
      <img :src="userInfo.head_img" alt="" style="width:74px;height:76px;border-radius: 50px;" v-if="userInfo.head_img">
      <img style="width:70px;border-radius: 50px;" src="../../../static/img2/xszy2.png" v-else alt="">
      <div class="pandect">
        <span class="spa1">作业总览</span>
        <span class="spa2">Results overview</span>
        <img class="spa3" src="../../../static/img2/zonglan1.png" alt="">
        <span class="spa4">有效训练： {{ sum }} 次</span>
        <span class="spa5">有效训练时长：{{ formatSeconds(allTime) }}</span>
      </div>
      <div class="statistics">

        <div style="width:200px;margin-top: 5px;">
          <p>
            <span class="progress_out">
              <span class="progress_in" :style="{ width: chartData11 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/youxi.png"></span>
            </span>

          </p>
          <p>
            <span class="progress_out1">
              <span class="progress_in1" :style="{ width: chartData22 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/dabiao.png"></span>
            </span>

          </p>
          <p>
            <span class="progress_out2">
              <span class="progress_in2" :style="{ width: chartData33 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/budabaio.png"></span>
            </span>
          </p>
        </div>
        <div class="percent">
          <p>{{ chartData11 }}%</p>
          <p>{{ chartData22 }}%</p>
          <p>{{ chartData33 }}%</p>
        </div>
        <div class="number_of">
          <p><img class="p1" src="../../../static/img2/uouxidia.png" alt=""><span class="number1">优秀
              （{{ chartData1 }}次）</span></p>
          <p><img class="p2" src="../../../static/img2/dabaidian.png" alt=""><span class="number2">达标
              （{{ chartData2 }}次）</span></p>
          <p><img class="p3" src="../../../static/img2/budadan.png" alt=""><span class="number3">不达标
              （{{ chartData3 }}次）</span></p>
        </div>
      </div>
    </div>
    <div class="options">
      <div class="type">
        <div class="direction1">
          <el-form :model="params2" label-width="80px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="作业名称:">
                  <el-input v-model="params2.name" placeholder="作业名称" @change="getScore()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态:">
                  <el-select v-model="params2.status" clearable @change="getScore()" placeholder="状态">
                    <el-option label="已完成" :value="1"></el-option>
                    <el-option label="未完成" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="typebox"></div>
    </div>
    <div class="tablelistcard">
      <!-- <el-table ref="filterTable" :data="tableData" style="width: 100%;max-height: 435px;margin-top: 45px;  " :row-class-name="tableRowClassName" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(25, 26, 31, 0.8)">
        <el-table-column prop="title" label="作业名称" show-overflow-tooltip width="195px" sortable align="center" column-key="date">
          <template slot-scope="scope">
            <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="gohandleEdit(scope.$index, scope.row)">{{ scope.row.title }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="learn_name" label="训练项目" show-overflow-tooltip width="300px">
        </el-table-column>
        <el-table-column prop="end_time" label="截止日期" width="180px" align="center">
        </el-table-column>
        <el-table-column prop="sum" label="操作次数" width="80px" align="center">
        </el-table-column>
        <el-table-column prop="type" label="状态" width="80px" align="center">
        </el-table-column>
        <el-table-column prop="time" label="完成时间" width="160px" align="center">
        </el-table-column>
        <el-table-column prop="total_score" label="得分" width="80px" align="center">
        </el-table-column>
        <el-table-column prop="total_time" label="用时" width="100px" align="center">
        </el-table-column>
        <el-table-column label="操作" width="140px" align="center">
          <template slot-scope="scope">
            <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.total_score!='——'">查看</a>
            <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="gohomework(scope.row)" v-if="scope.row.status=='2'">开始作业</a>
            <a size="mini" style="color:#C0C4CC;cursor:pointer;"  v-if="scope.row.status=='1'">已结束</a>
          </template>
        </el-table-column>
      </el-table> -->
      <el-card class="box-card" shadow="hover" v-for="(item, index) in tableData" :key="item.id">
        <div class="box-card-left">
          <span>{{ item.classify_name }}</span>
        </div>
        <div class="box-card-rigth">
          <div class="box-card-rigth-btn">
            <el-tag class="el-tag" size="small" type="warning"
              v-if="item.status != '1' && item.classify == 6 && item.teacher_type == 1"
              @click="dialogVisible = true; ids = item.id">开始作业</el-tag>
            <el-tag @click="setisshow(item, index)" size="small" class="el-tag"
              v-if="(!item.isshow && item.status != '1') && (item.classify == 2 || item.classify == 3)">上传作业</el-tag>
            <el-tag @click="downLoadWord(item)" size="small" class="el-tag" v-if="item.classify == 5">下载报告</el-tag>
            <el-tag @click="item.isshow = true; item.isfile = false; tableIndex = index" size="small" class="el-tag"
              v-if="item.classify == 5 && item.status != '1'">提交作业</el-tag>
            <el-tag @click="sethomeworkDocx(item, index)" size="small" class="el-tag"
              v-if="(item.isshow && item.status != '1') && item.classify == 5">确认提交</el-tag>
            <el-tag @click="sethomework(item)" size="small" class="el-tag"
              v-if="(item.isshow && item.status != '1') && (item.classify == 2 || item.classify == 3)">提交作业</el-tag>
            <el-tag @click="setfileshow(item, index)" class="el-tag" size="small"
              v-if="(item.type == '已完成' && !item.isfile && item.status != '1') && (item.classify == 2 || item.classify == 3)">上传附件</el-tag>
            <el-tag @click="setfile(item)" size="small" class="el-tag"
              v-if="(item.type == '已完成' && item.isfile && item.status != '1') && (item.classify == 2 || item.classify == 3)">提交附件</el-tag>
            <el-tag @click="gohomework(item)" class="el-tag" size="small" type="warning"
              v-if="(item.status == '2' && item.status != '1') && (item.classify == 4 || item.classify == 1)">开始作业</el-tag>
            <el-tag type="success" class="el-tag" @click="handleEdit(index, item)" size="small"
              v-if="item.total_score != '——' && (item.classify == 4 || item.classify == 1)">查看</el-tag>
            <el-tag type="info" size="small" v-if="item.status == '1'">已结束</el-tag>
            <el-tag type="success" size="small" v-if="item.type == '已完成'">已完成</el-tag>
          </div>
        </div>
        <div class="textbody">
          <!-- <el-form :inline="true" class="demo-form-inline">
            <el-row>
              <el-col :span="12">
                <el-form-item label="活动区域">
                  <el-select placeholder="活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form> -->
          <div class="textbody-left">
            <span class="textbody-left-title">
              <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="gohandleEdit(index, item)">{{ item.title }}</a>
            </span>
            <div class="textbody-left-span" v-show="item.classify == 4 || item.classify == 1">
              <span>训练项目 : {{ item.learn_name }}</span>
            </div>
            <div class="textbody-left-span">
              <span>操作次数 : {{ item.sum }}</span>
            </div>
            <div class="textbody-left-span">
              <span>状态 : {{ item.type }}</span>
            </div>
            <div class="textbody-left-span" v-show="item.classify == 2 || item.classify == 3">
              <span>说明理解 : {{ item.student_des }}</span>
            </div>
            <div class="textbody-left-span" v-show="item.classify == 2 || item.classify == 3">
              <span>附件 :
                <el-link type="primary" v-for="(annexfile, indfile) in item.annex" :key="indfile" :href="annexfile.url"
                  :underline="false">
                  <span>{{ annexfile.name }}</span>
                </el-link>
              </span>
            </div>
            <div class="textbody-left-span">
              <span>完成时间 : {{ item.time }}</span>
            </div>
          </div>
          <div class="textbody-left" style="width: 20%;">
            <div class="textbody-left-span">
              <span>得分 : {{ item.total_score }}</span>
            </div>
            <div class="textbody-left-span">
              <span>用时 : {{ item.total_time }}</span>
            </div>
            <div class="textbody-left-span">
              <span>截止日期 : {{ item.end_time }}</span>
            </div>
            <div class="textbody-left-span" style="display: flex;width: 310px;"
              v-if="item.classify == 2 || item.classify == 3">
              <span>作业图片 : </span>
              <div style="position: relative;" v-for="(itemimg, indexf) in item.student_answer" :key="indexf">
                <el-image class="avatar" :preview-src-list="item.student_answer" :src="itemimg" fit="cover"
                  style="width: 100px; height: 100px;margin-left: 10px;" />
              </div>
            </div>
            <div class="textbody-left-span" style="display: flex;width: 310px;" v-if="item.classify == 5">
              <span>作业文档 : </span>
              <div style="position: relative;" v-for="(itemUrl, indexf) in item.student_answer" :key="indexf">
                &nbsp;&nbsp;<a style="color:white;" :href="itemUrl.url">{{ itemUrl.name }}</a>
              </div>
            </div>
          </div>
          <div class="textbody-left" style="width: 28%;margin-left: 50px;" v-if="item.isshow && item.classify == 5">
            <div class="textbody-left-span">
              <span style="font-size: 14px;">上传文件 : </span>
            </div>
            <!-- <div class="upload_portrait" style="display: flex;align-items: center;"> -->
            <div style="display: flex;justify-content: space-between;margin:10px 0;">
              <div style="width: 100%;display: flex;justify-content: space-between;" v-if="tableWord[index]">
                <div>
                  <i class="el-icon-loading" v-if="tableWord[index].loading"></i>&nbsp;
                  <a style="color:white;" :href="tableWord[index].url">{{ tableWord[index].name }}</a>
                </div>
                <i class="el-icon-delete" @click="handleRemove(index)"></i>
              </div>
            </div>
            <el-upload class="user_photo" :auto-upload="true" :show-file-list="false" accept=".docx" upFolder="cyrcglCpgl"
              action="#" :http-request="(e) => importdownClick(e, index)">
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
            <!-- </div> -->
            <div class="textbody-left-span" style="padding-bottom: 4px;">
              <span style="font-size: 14px;">说明理解:</span>
            </div>
            <div class="textbody-left-span" style="padding-bottom: 4px;">
              <el-input v-model="item.textarea" type="textarea" placeholder="请输入内容"
                style="background-color: #1b1c21;border:1px solid #37373f;" />
            </div>
          </div>
          <div class="textbody-left" style="width: 28%;margin-left: 50px;"
            v-if="item.isshow && (item.classify == 2 || item.classify == 3)">
            <div class="textbody-left-span">
              <span style="font-size: 14px;">上传照片 : </span>
            </div>
            <div class="upload_portrait" style="display: flex;align-items: center;">
              <div style="display: flex;justify-content: space-between;">
                <div style="position: relative;" v-for="(itemimg, indexf) in item.img" :key="indexf">
                  <el-image class="avatar" :preview-src-list="item.img" :src="itemimg" fit="cover"
                    style="width: 80px; height: 80px;margin-right: 10px;" />
                  <i class="el-icon-delete-solid" @click="item.img.splice(indexf, 1)"
                    style="position: absolute;top: -12px;right: 0px;font-size: 18px;cursor: pointer"></i>
                </div>
              </div>
              <el-upload v-show="item.img.length < 2" class="user_photo" :auto-upload="true" :show-file-list="false"
                accept=".jpg,.jpeg,.png" upFolder="cyrcglCpgl" action="#" :http-request="importClick">
                <div @click="setind(index)" slot="trigger"
                  style="width: 80px; height: 80px;border: 1px dashed #d9d9d9;display: flex; align-items: center;justify-content: center;">
                  <i class="el-icon-plus"></i>
                </div>
              </el-upload>
            </div>
            <div class="textbody-left-span" style="padding-bottom: 4px;">
              <span style="font-size: 14px;">说明理解:</span>
            </div>
            <div class="textbody-left-span" style="padding-bottom: 4px;">
              <el-input v-model="item.textarea" type="textarea" placeholder="请输入内容"
                style="background-color: #1b1c21;border:1px solid #37373f;" />
            </div>
          </div>
          <div class="textbody-left" style="width: 28%;margin-left: 50px;"
            v-if="item.isfile && (item.classify == 2 || item.classify == 3)">
            <div class="textbody-left-span">
              <span style="font-size: 14px;">上传附件 : </span>
            </div>
            <el-form :inline="true" class="demo-form-inline">
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <div class="upload_portrait" style="display: flex;flex-direction: column;">
                      <div style="display: flex;justify-content: space-between;width: 200px;margin-top: 10px;"
                        v-for="(itemfile, fileind) in item.file" :key="fileind">
                        <el-link type="primary" :underline="false">
                          <span>{{ itemfile.name }}</span>
                        </el-link>
                        <el-link type="primary" :underline="false">
                          <i class="el-icon-delete-solid" @click="item.file.splice(fileind, 1)"></i>
                        </el-link>
                      </div>
                      <el-upload v-show="item.file.length < 1" class="user_photo" :auto-upload="true"
                        :show-file-list="false" upFolder="cyrcglCpgl" action="#" :http-request="importClickfile">
                        <div @click="setind(index)" slot="trigger"
                          style="width: 80px; height: 80px;border: 1px dashed #d9d9d9;display: flex; align-items: center;justify-content: center;margin-top: 10px">
                          <i class="el-icon-plus"></i>
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>
    <div style="margin-top:110px">
      <div class="bottomtion111" v-show="Hidethe_paging">
        <el-pagination background @current-change="pageCurrentChange" :pager-count="pageform.countPage"
          :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total"
          :page-size='8'>
        </el-pagination>
      </div>
    </div>
    <Beginindex v-if="dialogVisible" :dialogVisible="dialogVisible" :id="ids"
      @updatedialogVisibles="dialogVisible = false" />
  </div>
</template>

<script>
import VePie from 'v-charts/lib/pie.common'
import Beginindex from './homeWorkModal/Beginindex'

import { categoryTree } from '../../restful/api'
export default {
  inject: ['reload'],
  components: { VePie, Beginindex },
  name: 'Practices',

  data() {
    this.chartSettings = {
      radius: 50,
      offsetY: 100,
      label: {
        show: false,
      },
    }
    return {
      ids: "",
      cateTree: [],
      ind: '',
      classData: [],
      categoryTwoList: [],
      gradeData: [],
      classSort: 0,
      gradeSort: 0,
      userInfo: {},
      Hidethe_paging: true,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      chartData1: [],
      chartData2: [],
      category_id: '',
      somee: '',
      chartData3: [],
      chartData11: [],
      params3: {
        type: 'score',
        user_id: this.$store.getters.getUserInfo.id,
      },
      loading: true,
      chartData22: [],
      chartData33: [],
      // 分页插件
      pageform: {
        total: null,
        pages: 1, // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 8, // 每页显示条目个数
        countPage: 11,
      },
      tableData: [],
      practiceList: [],
      // progress_width:80,
      categoryList: [],
      allTime: 0,
      value: '',
      count: '',
      count1: '',
      count2: 1,
      count3: 3,
      of_hidden: false,
      com_plete: true,
      sum: '',
      value2: '',
      code: '',
      loading: true,
      disabled: true,
      params2: {
        page_size: 8,
        page: 1,
        status: null,
        name: null,
      },
      tableWord: [],
      tableIndex: 0,
      dialogVisible: false
    }
  },
  methods: {
    // 下载文件
    downLoadWord(item) {
      item.detail.forEach(loadItem => {
        const aLink = document.createElement("a")
        aLink.style.display = 'none';
        aLink.download = loadItem.name
        aLink.href = loadItem.url
        // fetch(load.url).then(res => {
        //   console.log(res);
        // })
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      })
    },
    // 点击了上传图片
    setisshow(val, ind) {
      this.tableData[ind].isshow = true
      this.tableData[ind].isfile = false
    },
    setfileshow(val, ind) {
      this.tableData[ind].isshow = false
      this.tableData[ind].isfile = true
    },
    setfile(e) {
      console.log(e)
      if (e.file.length <= 0) {
        this.$message({
          message: '请先上传附件！',
          type: 'warning',
        })
        return false
      } else {
        let obj = {
          id: e.mark_id,
          annex: JSON.stringify(e.file),
        }
        this.$http.updateannex(obj).then((res) => {
          console.log(res)
          this.$message({
            message: '附件上传成功！',
            type: 'success',
          })
          this.getScore()
        })
      }
    },
    importClick(e) {
      console.log(e)
      const formData = new FormData()
      formData.append('file', e.file)
      this.$http.setimg(formData).then((res) => {
        this.tableData[this.ind].img.push(res.data.url)
      })
    },
    importdownClick(e, index) {
      this.tableWord[index] = { name: e.file.name, url: "", loading: true }
      this.$forceUpdate()
      console.log(e, index);
      const formData = new FormData()
      formData.append('file', e.file)
      this.$http.setWord(formData).then((res) => {
        console.log(res);
        setTimeout(() => {
          this.tableWord[index] = { name: e.file.name, url: res.data.url, loading: false }
          this.$forceUpdate()
          console.log(this.tableWord[index]);
        }, 1000)
      })

    },
    handleRemove(index) {
      console.log(index);
      this.tableWord.splice(index, 1);
    },
    // 上传图片
    importClickfile(e) {
      console.log(e)
      const formData = new FormData()
      formData.append('file', e.file)
      this.$http.setimg(formData).then((res) => {
        console.log(res)
        let obj = {
          name: e.file.name,
          url: res.data.url,
        }
        this.tableData[this.ind].file.push(obj)
      })
    },
    // 存储下标
    setind(e) {
      this.ind = e
    },
    //获取随机码
    getsjCode() {
      this.$http.getsjCode().then((res) => {
        if (res.code == 200) {
          this.code = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    sethomeworkDocx(e, index) {
      console.log(e, index, this.tableWord[index])
      if (this.tableWord[index].url == "") {
        this.$message({
          message: '还未上传文件！',
          type: 'warning',
        })
        return false
      } else {
        let obj = {
          assignment_id: e.id,
          student_answer: [this.tableWord[index]],
          student_des: e.textarea,
        }
        this.$http.insertmark(obj).then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
            this.getScore()
          }
        })
      }
    },
    // 提交作业
    sethomework(e) {
      console.log(e)
      if (e.img.length <= 0) {
        this.$message({
          message: '请先上传图片！',
          type: 'warning',
        })
        return false
      } else {
        let obj = {
          assignment_id: e.id,
          student_answer: e.img,
          student_des: e.textarea,
        }
        this.$http.insertmark(obj).then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
            this.getScore()
          }
        })
      }
    },
    // 开始作业
    gohomework(val) {
      var baseurl = this.GLOBAL.BASE_URL
      // console.log(this.code)
      window.open(
        val.learn_url +
        '?user_id=' +
        this.$store.getters.getUserInfo.id +
        '-' +
        val.id +
        '+' +
        baseurl +
        '+' +
        this.code +
        '+' +
        val.cate_id +
        '+' +
        val.content
      )
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row'
      } else if (rowIndex === 1) {
        return 'success-row'
      } else if (rowIndex === 2) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      } else if (rowIndex === 4) {
        return 'warning-row'
      } else if (rowIndex === 5) {
        return 'success-row'
      } else if (rowIndex === 6) {
        return 'warning-row'
      } else if (rowIndex === 7) {
        return 'success-row'
      } else if (rowIndex === 8) {
        return 'warning-row'
      } else if (rowIndex === 9) {
        return 'success-row'
      }
      return ''
    },
    /* 分页插件 */
    // pageNum (当前页数)改变时会触发
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      console.log(val)
      this.pageform.pageNum = val
      // console.log(this.pageform.pageNum)
      this.params2.page = val
      this.getScore()
    },
    //获取分类树
    getCategoryTree() {
      this.$http.categoryTree(this.params3).then((res) => {
        this.cateTree = res.data
      })
    },
    getUser() {
      if (this.$cookies.get('token')) {
        this.$http.getUserInfo().then((res) => {
          this.userInfo = res.data
          // console.log(this.userInfo)
          if (res.data.head_img) {
            if (res.data.head_img.indexOf('http') !== -1) {
              this.userInfo.head_img = res.data.head_img
            } else {
              this.userInfo.head_img = this.GLOBAL.BASE_URL + res.data.head_img
            }
          } else {
            this.userInfo.head_img = ''
          }
          this.$store.commit('SetUserInfo', res.data)
          //   console.log(this.userInfo)
        })
      }
    },
    // 获取分类列表
    getCategoryList() {
      this.practiceList = []
      this.$http
        .categoryList()
        .then((res) => {
          if (res.code !== 0) {
            this.categoryList = res.data
            //  console.log( this.categoryList)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          // console.log(err);
        })
    },
    handleEdit(index, row) {
      this.$router.push({
        name: 'homeworkinfor',
        query: {
          id: row.mark_id,
          title: '作业成绩',
        },
      })
    },
    gohandleEdit(index, row) {
      this.$router.push({
        name: 'Homeworkinfordata',
        query: {
          id: row.id,
          title: row.title,
          start_time:false,
        },
      })
    },
    getScore() {
      this.$http.gethomework(this.params2).then((res) => {
        console.log(res)
        if (res.code !== 0) {
          this.tableData = res.data.list.data
          this.loading = false
          this.pageform.pages = res.data.list.current_page
          console.log(this.pageform.pages)
          this.pageform.total = res.data.list.total
          // console.log(this.pageform.pages)
          // console.log(this.pageform.pages)
          if (this.pageform.pages < this.pageform.total) {
            this.Hidethe_paging = true
          } else {
            this.Hidethe_paging = false
          }
          this.allTime = res.data.allTime
          console.log(res, '234234234')
          this.chartData1 = res.data.dabiao.height
          this.chartData2 = res.data.dabiao.middle
          this.chartData3 = res.data.dabiao.low
          this.sum = this.chartData1 + this.chartData2 + this.chartData3
          this.chartData11 = ((this.chartData1 / this.sum) * 100).toFixed(2)
          this.chartData22 = ((this.chartData2 / this.sum) * 100).toFixed(2)
          this.chartData33 = ((this.chartData3 / this.sum) * 100).toFixed(2)
          if (this.chartData11 == 'NaN') {
            this.chartData11 = 0
          }
          if (this.chartData22 == 'NaN') {
            this.chartData22 = 0
          }
          if (this.chartData33 == 'NaN') {
            this.chartData33 = 0
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onChangeHandle(item, index) {
      // console.log(item)
      let category_id = item.value
      this.disabled = false
      this.params2.page = 1
      this.pageform.pageNum = 1
      this.params2.category_id = category_id
      this.getCourseList(category_id)
      let arr = this.cateTree.find((v) => v.value === item.value)
      // console.log(arr);
      this.count = index
      this.count2 = ''
      this.count1 = ''
      this.count3 = 3
      this.categoryTwoList = arr.children
      this.getScore()
    },
    color: function (index) {
      if (this.count === index) {
        return 'activee'
      }
    },
    clearHandle() {
      delete this.params2.learn_id
    },
    complete() {
      this.count3 = 3
      this.count1 = ''
      // console.log(this.count)
      this.tableData = []
      this.pageform.pageNum = 1
      this.show = true
      //  console.log( this.params.category_id)
      if (this.count == 0) {
        this.params2.category_id = 2
      } else {
        this.params2.category_id = 17
      }
      this.params2 = {
        page_size: 8,
        page: 1,
        category_id: this.params2.category_id,
      }
      this.getScore()
    },
    color: function (index) {
      if (this.count === index) {
        return 'activee'
      }
    },
    color2: function (index) {
      if (this.count1 === index) {
        return 'activ'
      }
    },
    // 获取训练列表
    getCourseList(category_id) {
      this.practiceList = []
      this.params2.category_id = category_id
      this.$http.courseAllList({ category_id: category_id }).then((res) => {
        if (res.code !== 0) {
          this.practiceList = res.data.learn
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  mounted() {
    this.getCategoryList()
    this.getCategoryTree()
    this.getScore()
    this.getCourseList()
    this.getUser()
  },
  created() {
    this.getsjCode()
  },
}
</script>

<style lang="less" >
@import '../../../static/fonts/stylemain/style.less';
.el-card{
  background-color: @bg1;
}
.el-icon-delete-solid:hover {
  color: #009ad0;
}

.upload_portrait {
  width: 200px;
  height: 120px;
  padding: 0 !important;
  z-index: 9;

  /* 照片 */
  .user_photo {
    cursor: pointer;
    display: flex;

    i {
      font-size: 18px;
    }
  }
}

.el-input__inner::-webkit-input-placeholder {
  color: @writing1;
}

/* 火狐 */
.el-input__inner:-moz-placeholder {
  color: @writing1;
}

/*ie*/
.el-input__inner:-ms-input-placeholder {
  color: @writing1;
}

/deep/.el-form-item__label {
  color: @writing1;
}

.el-tag {
  cursor: pointer
}

.textbody {
  // width: 100%;
  margin-bottom: 18px;
  margin-top: 38px;
  font-size: 14px;
  border-top: solid 1px #c0c4cc;
  display: flex;
  justify-content: normal !important;

  // justify-content: space-around;
  .textbody-left {
    padding: 10px;
    width: 30%;
    display: flex;
    flex-direction: column;

    .textbody-left-title {
      font-size: 18px;
      color: #009ad0;
    }

    .textbody-left-span {
      margin-top: 10px;
      font-size: 16px;
      color:  @writing;
    }
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  border: none;
  color: #c0c4cc;
  position: relative;
  margin-top: 10px;
}

.box-card-left {
  position: absolute;
  top: 0px;
  width: 100px;
  height: 30px;
  background-color: #009ad0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-right-radius: 4px;
  font-size: 18px;
  font-weight: 500;
}

.box-card-rigth {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  .box-card-rigth-btn {
    padding: 6px;
  }
}

@media screen and (max-width: 768px) {
  .bossboxbodywork {
    width: 100%;
    height: 100%;
    background-color: #212229;
    overflow: hidden;

    .activee {
      background: #009ad3;
      padding: 10px 10px 10px 10px;
      border-radius: 35px;
    }

    .activ {
      background: #009ad3;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .schedule {
      width: 100%;
      height: 100rem;
      background-color: #212229;
      margin: auto;
      position: relative;

      img {
        position: absolute;
        top: 8rem;
        left: 7rem;
      }

      .pandect {
        width: 234px;
        height: 82px;
        position: absolute;
        top: 8rem;
        left: 45rem;

        .spa1 {
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 24px;
        }

        .spa2 {
          position: absolute;
          top: 14px;
          left: 105px;
          color: #909399;
          font-size: 14px;
        }

        .spa3 {
          position: absolute;
          top: 34px;
          left: 0;
        }

        .spa4 {
          position: absolute;
          top: 40px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }

        .spa5 {
          position: absolute;
          top: 59px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }
      }

      .statistics {
        width: 454px;
        height: 110px;
        position: absolute;
        top: 38rem;
        left: 7rem;

        .progress_out {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 10px;
          left: 0;
          margin-right: 10px;

          .progress_in {
            display: inline-block;
            height: 5px;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #245556, #24ab95, #06f0c9);
            // background: rgba(24, 201, 176, 0.8);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;

            img {
              position: absolute;
              top: -14px;
            }
          }
        }

        .progress_out1 {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 20px;
          left: 0;
          margin-right: 10px;

          .progress_in1 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #2e5a6a, #3b8eae, #44b3f0);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
          }
        }

        .progress_out2 {
          display: inline-block;
          width: 100%;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(56, 41, 47, 0.7);
          position: relative;
          top: 30px;
          left: 0;
          margin-right: 10px;

          .progress_in2 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #643338, #a9393c, #ff3131);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
            // left: 0;
          }
        }

        .percent {
          position: absolute;
          top: 15px;
          left: 220px;
          width: 50px;
          height: 70px;

          p {
            padding-top: 5px;
            font-size: 16px;
            color: #fff;
          }
        }

        .number_of {
          position: absolute;
          top: 34rem;
          left: 0rem;
          width: 150px;
          height: 70px;

          .p1 {
            position: absolute;
            top: 0;
            left: 0;
          }

          .p2 {
            position: absolute;
            top: 25px;
            left: 0;
          }

          .p3 {
            position: absolute;
            top: 52px;
            left: 0;
          }

          .number1 {
            position: absolute;
            left: 30px;
            top: 0;
            color: #fff;
          }

          .number2 {
            position: absolute;
            left: 30px;
            top: 26px;
            color: #fff;
          }

          .number3 {
            position: absolute;
            left: 30px;
            top: 52px;
            color: #fff;
          }
        }
      }
    }

    .options {
      width: 100%;
      // height: 270px;
      background-color: #191a1f;
      overflow: hidden;

      .type {
        width: 100%;
        height: 30rem;
        background-color: #111217;
        margin: 20px auto 0;
        position: relative;
      }

      .direction1 {
        width: 100%;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem1 {
        line-height: 45rem;
        float: left;
        margin-left: 5rem;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          margin-top: 15px;
        }
      }

      .directionitem2 {
        font-size: 14px;
        color: #fff;
        width: 85%;
        height: 100%;
        margin: 20rem auto 0;
        overflow: hidden;

        span {
          line-height: 10rem;
          display: flex;
          justify-content: space-around;
          height: 35px;
          padding: 2.6rem;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 100%;
        max-height: 320rem;
        background-color: #111217;
        margin: 20px auto;
        position: relative;
        overflow: hidden;
      }
    }

    .tablelistcard {
      width: 1316px;
      // height: 240rem;
      margin: auto;
      overflow: hidden;
      display: none;

      .el-table .warning-row {
        background: #24252c;
        color: rgb(203, 200, 200);
      }

      .el-table .success-row {
        background: #2a2b32;
        color: rgb(203, 200, 200);
      }
    }

    .bottomtion111 {
      height: 65px;
      width: 100%;
      background-color: #2f3037;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
}

@media screen and (min-width: 768px) {
  .bossboxbodywork {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: @bg3;
    overflow: hidden;

    .activee {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .activ {
      background: #009ad3;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .schedule {
      width: 1216px;
      height: 221px;
      background-color: @bg3;
      margin: auto;
      position: relative;

      img {
        position: absolute;
        top: 77px;
        left: 197px;
      }

      .pandect {
        width: 234px;
        height: 82px;
        position: absolute;
        top: 75px;
        left: 286px;

        .spa1 {
          position: absolute;
          top: 0;
          left: 0;
          color: @writing;
          font-size: 24px;
        }

        .spa2 {
          position: absolute;
          top: 14px;
          left: 105px;
          color: #909399;
          font-size: 14px;
        }

        .spa3 {
          position: absolute;
          top: 34px;
          left: 0;
        }

        .spa4 {
          position: absolute;
          top: 40px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }

        .spa5 {
          position: absolute;
          top: 59px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }
      }

      .statistics {
        width: 454px;
        height: 110px;
        position: absolute;
        top: 65px;
        left: 570px;

        .progress_out {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 10px;
          left: 0;
          margin-right: 10px;

          .progress_in {
            display: inline-block;
            height: 5px;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #245556, #24ab95, #06f0c9);
            // background: rgba(24, 201, 176, 0.8);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;

            img {
              position: absolute;
              top: -14px;
            }
          }
        }

        .progress_out1 {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 20px;
          left: 0;
          margin-right: 10px;

          .progress_in1 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #2e5a6a, #3b8eae, #44b3f0);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
          }
        }

        .progress_out2 {
          display: inline-block;
          width: 100%;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(56, 41, 47, 0.7);
          position: relative;
          top: 30px;
          left: 0;
          margin-right: 10px;

          .progress_in2 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #643338, #a9393c, #ff3131);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
            // left: 0;
          }
        }

        .percent {
          position: absolute;
          top: 15px;
          left: 220px;
          width: 50px;
          height: 70px;

          p {
            padding-top: 5px;
            font-size: 16px;
            color: @writing;
          }
        }

        .number_of {
          position: absolute;
          top: 16px;
          left: 295px;
          width: 150px;
          height: 70px;

          .p1 {
            position: absolute;
            top: 0;
            left: 0;
          }

          .p2 {
            position: absolute;
            top: 25px;
            left: 0;
          }

          .p3 {
            position: absolute;
            top: 52px;
            left: 0;
          }

          .number1 {
            position: absolute;
            left: 30px;
            top: 0;
            color: @writing;
          }

          .number2 {
            position: absolute;
            left: 30px;
            top: 26px;
            color: @writing;
          }

          .number3 {
            position: absolute;
            left: 30px;
            top: 52px;
            color: @writing;
          }
        }
      }
    }

    .options {
      width: 100%;
      //  height: 270px;
      background-color: @bg2;
      overflow: hidden;

      .type {
        width: 1216px;
        height: 68px;
        background-color: @bg1;
        margin: 35px auto 0;
        position: relative;
      }

      .direction1 {
        width: 100%;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem1 {
        line-height: 35px;
        margin-left: 184px;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          float: left;
          margin-top: 15px;
        }
      }

      .directionitem2 {
        margin-left: 160px;
        font-size: 14px;
        color: #fff;
        width: 891px;
        //  height: 127px;
        overflow: hidden;

        span {
          margin-top: 15px;
          margin-bottom: 17px;
          margin-left: 39px;
          float: left;
          height: 35px;
          line-height: 35px;
          padding: 0 10px 0 10px;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 1216px;
        max-height: 130px;
        background-color: #111217;
        margin: 20px auto 22px;
        position: relative;
        overflow: hidden;

        .typeitem1 {
          width: 1116px;
          height: 67px;
          border-bottom: 2px solid #1a1b20;
        }

        .typeitem2 {
          width: 1216px;
          height: 67px;
        }
      }
    }

    .tablelistcard {
      width: 1316px;
      margin: auto;
    }

    .bottomtion111 {
      height: 65px;
      width: 100%;
      background-color: @bottomtion;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Homework.vue